console.log(process.env.REACT_APP_BASE_API_URL)
console.log(process.env.REACT_APP_FRONTEND_URL)
export const BASE_API_URL =
  process.env.REACT_APP_BASE_API_URL || ' http://localhost:3030'
export const TARGET_ORIGIN =
  process.env.REACT_APP_FRONTEND_URL || 'https://localhost:3000'
